import React from "react";
import { FontStyles } from "../utils/font-styles.ts";

const stats = [
  {
    key: "properties sold last year",
    value: "11,700+",
  },
  {
    key: "solicitor estate agents to choose from",
    value: "130",
  },
  {
    key: "leads than other websites",
    value: "4x more",
  },
  {
    key: "of Home Report valuation achieved*",
    value: "2% more",
  },
];

const outerContainerStyle =
  "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 lg:gap-24 pt-7.5 pb-7.5 " +
  "items-center md:items-start md:justify-center w-full max-w-espc-max-content mx-auto";
const innerContainerStyle = "flex flex-col gap-0.5 items-center self-stretch w-full";
const valueStyle = `flex items-center text-loch text-center font-semibold ${FontStyles.h2}`;
const nameStyle = `flex items-center text-center text-light-slate ${FontStyles.h6}`;

export const Statistics = () => {
  if (stats.length === 0) {
    return null;
  }
  return (
    <div className={outerContainerStyle}>
      {stats.map((s) => (
        <React.Fragment key={s.key}>
          <div className={innerContainerStyle}>
            <div className={valueStyle}>{s.value}</div>
            <div className={nameStyle}>{s.key}</div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
